import React, { useState, useEffect } from "react";
import { MdOutlineErrorOutline } from "react-icons/md";
import { VscCloudDownload } from "react-icons/vsc";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { useAppDispatch, useAppSelector } from "../../../useStore";
import { TaskTitles } from "../../../components/JobInputData";
import { EntriesPerPage, TableProgressBar } from "../../../components/TableOptions";
import Pagination from "../../../components/Pagination";
import { applicationassigned, reset } from "../../../features/Applicant/applicantSlice";
import moment from "moment";
import swal from "sweetalert";
import { Toaster } from "react-hot-toast";


const TaskTable = ({ pageHeader }) => {

 const dispatch = useAppDispatch();
 const {
  applicationassigneddata,
  applicationassignedisError,
  applicationassignedisLoading,
  applicationassignedmessage,
 } = useAppSelector((state: any) => state.applicant);

 useEffect(() => {
  dispatch(applicationassigned());
 }, [dispatch]);

 useEffect(() => {
  if (applicationassignedisError) {
   swal({
    title: "error",
    text: applicationassignedmessage,
    icon: "error",
   });
   dispatch(reset());
  }
 }, [applicationassignedisError, applicationassignedmessage, dispatch]);

 const [entriesperpage, setEntriesPerPage] = useState(() => {
  return "8";
 });
 const [displayData, setDisplayData] = useState([]);

 return (
  <div>
   <Toaster
    position="top-center"
    toastOptions={{
     duration: 5000,
     error: {
      duration: 20000,
     },
    }}
   />
   <section className="md-ui component-data-table">
    <header className="main-table-header">
     <div className="main-table-search-container">
      <h1 className="table-header--title">{pageHeader}</h1>
      <div>
       <EntriesPerPage
        data={displayData}
        entriesperpage={entriesperpage}
        setEntriesPerPage={setEntriesPerPage}
       />
      </div>
      <input className="search__input" type="text" placeholder="Search" />
     </div>
    </header>
    <div className="main-table-wrapper">
     <table className="main-table-content">
      <thead className="data-table-header">
       <tr className="data-table-row">
        {TaskTitles.map((title: any, i: any) => (
         <td
          className="table-datacell datatype-string headerTitles" key={i} >
          {title}
         </td>
        ))}
       </tr>
      </thead>
      <tbody className="data-table-content">
       {applicationassignedisLoading ? (
        <tr>
         <td className="table-msg" colSpan={12}>
          <VscCloudDownload size={75} />
          <p>Fetching request...</p>
          <div id="container-progressbar-container">
           <TableProgressBar />
          </div>
         </td>
        </tr>
       ) : displayData?.length === 0 ||
        displayData?.length === undefined ? (
        <tr>
         <td className="table-msg" colSpan={12}>
          <MdOutlineErrorOutline size={75} />
          <p>No Record found!</p>
         </td>
        </tr>
       ) : (
        displayData?.map((row: any, i: any) => (
         <tr className="data-table-row" key={i}>
          <td className="table-datacell datatype-string">
           <AccountCircle />
          </td>

          <td className="table-datacell datatype-numeric">
           {"Edit"}
          </td>
          <td className="table-datacell datatype-numeric">
           {row?.title}
          </td>
          <td className="table-datacell datatype-numeric">
           {row?.firstName} {row?.LastName}
          </td>

          <td className="table-datacell datatype-numeric">
           {moment(row?.createdAt).format("DD-MMMM-YYYY")}
          </td>
          <td className="table-datacell datatype-numeric">
           <button className="severity-low">
            {row?.applicationStatus}
           </button>
          </td>
          <td className="table-datacell datatype-numeric">
           {row?.email}
          </td>

          <td className="table-datacell datatype-numeric">
           {row?.phoneNumber}
          </td>
          <td className="table-datacell datatype-numeric">
           {row?.location}
          </td>
          <td className="table-datacell datatype-string">
           {row?.noticePeriod + " week"}
          </td>
         </tr>
        ))
       )}
      </tbody>
     </table>
    </div>
    <div className="table-footer">
     <div>
      <Pagination
       setDisplayData={setDisplayData}
       data={applicationassigneddata?.data}
       entriesperpage={entriesperpage}
       Total={"Applicant"}
      />
     </div>
    </div>
   </section>
  </div>
 );
};

export default TaskTable;
